import { useMutation } from "urql";

import { UpdateWaiveDocument } from "../../../graphql/generated.ts";

export function useUpdateWaive() {
  return useMutation(UpdateWaiveDocument);
}
